/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "apiNtrepid",
            "endpoint": "https://5bnuvho9qg.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:1be515b6-bef6-4bca-ba99-d44b152c3458",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_dqbZhVEvH",
    "aws_user_pools_web_client_id": "60a2a3oufvuecrk84st24c6dsa",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "ntrepid-bucketc13d4-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "customers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "products-dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
